import {Component, ChangeDetectorRef, Output, Input, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';
import {ComPortfolioNotesGridLayoutService} from './com-portfolio-notes.grid-layout.service';
import {IPortfolioNotes} from '@irb/irb-editors/irb-editors.model';
import {CalltoactionService} from '@irb/irb-common/components/calltoaction/calltoaction.service';
import {UtilityService} from '@irb/irb-common/services/utility.service';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import {PageService} from '@irb/irb-common/services/page.service';
import {takeUntil} from 'rxjs/operators';
import {ReplaySubject} from 'rxjs';
import {IUserDetails} from '@irb/app.model';
import {IrbAgGridExportService} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service";
import {DatePipe} from "@angular/common";
import {EasternTimePipe} from "@irb-common/pipes/EasternTimePipe";


@Component({ standalone: false,
    selector: 'irb-com-portfolio-notes',
    templateUrl: './com-portfolio-notes.component.html',
    styleUrls: ['./com-portfolio-notes.component.scss'],
    providers: [DatePipe, EasternTimePipe],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPortfolioNotesComponent {
    notesPattern = /^[a-zA-Z0-9][a-zA-Z0-9 ~`!@#$%\^&\*()-_+={}\[\]|\\:;""'',<.>?\/ ]*$/i;
    @Output() change = new EventEmitter<boolean>();
    private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
    _data: Array<IPortfolioNotes>;
    _activeRowCount: number;
    _archivedRowCount: number;
    _grid: any;
    _gridOptions: any;
    _listOfNotes: IPortfolioNotes = {} as IPortfolioNotes;
    filterType = 'allNotes';
    comments: string;
    faDownload = faDownload;
    multiLineComment: string;
    canNotCreateNote: boolean = true;
    userDetail: string;
    currentSelectedTime: any;
    isNoteBeingEdited = false;
    editNoteParams: any;
    isUiTest = false;
    frameworkComponents: any;

    constructor(
        public ies: IrbEditorsService,
        private gls: ComPortfolioNotesGridLayoutService,
        private ctas: CalltoactionService,
        private util: UtilityService,
        public ps: PageService,
        public ges: IrbAgGridExportService,
        private datePipe: DatePipe,
        private easternTimePipe: EasternTimePipe
    ) {
        this.currentSelectedTime = new Date();
        this.gridOptions = {
            columnDefs: this.gls.getColumnDefs(this),            
            floatingFilter: false,
            overlayNoRowsTemplate: "No active notes for this portfolio.",
            context: {componentParent: this},
            isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
            doesExternalFilterPass: this.doesExternalFilterPass.bind(this)
        };
        
        this.frameworkComponents = this.gls.getFrameworkComponents();

        this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d: IUserDetails) => {
            if (typeof d !== "undefined") {
                this.userDetail = d.userID;
            }
        });
    }
    editNote(params: any) {
        if(this.isNoteBeingEdited && this.editNoteParams) {
            if(!((params?.data?.isNew && params?.data?.createdDate === this.editNoteParams?.data?.createdDate) ||
                ((!params?.data?.isNew) && (params?.data?.noteId === this.editNoteParams?.data?.noteId)))) {
                // if not the note being edited then update the content.
                this.isNoteBeingEdited = true;
                this.canNotCreateNote = false;
                this.multiLineComment = params.value;
                this.editNoteParams = params;
            }
        } else {
            this.isNoteBeingEdited = true;
            this.canNotCreateNote = false;
            this.multiLineComment = params.value;
            this.editNoteParams = params;
        }
    }

    onGridReady(params: any) {
        this.grid = params;
        this.grid.api.onFilterChanged();
        this.loadGrid();
        this.load();
    }

    loadGrid() {
        this.grid.api.setGridOption('rowData', this.data);
        this.updateRowCounts();        
    }

    load() {
        const sortByKey = this.util.sortByKey;
    }

    gridChangeEvent(noteId: number, priority: string) {
        this.data.forEach((nt: any) => {
            if (nt.noteId === noteId) {
                nt.priority = priority;
            }
        });
        this.loadGrid();
        this.change.emit(true);
    }

    deleteAll() {
        for (let i = 0; i < this.data.length; i++) {
            if (!this.data[i].isArchive) {
                if(this.data[i].isNew) {
                    this.data[i].isNoteEdited = true;
                    this.data.splice(i--,1);
                } else {
                    this.data[i].isUIdeleted = true;
                }
            }
        }
        this.cancelEditNote();
        this.loadGrid();
        this.change.emit(true);
        this.setOverlayNoRowsTemplate();
    }

    delete(cc: any) {
        for (let i = 0; i < this.data.length; i++) {
            if (this.data[i].noteId === cc.noteId) {
                if(this.data[i].isNew) {
                    this.data.splice(i--,1);
                    this.data[i].isNoteEdited = true;
                } else {
                    this.data[i].isUIdeleted = true;
                }
                break;
            }
        }
        this.onNoteBeingDeleted(cc);
        this.loadGrid();
        this.change.emit(true);
        this.setOverlayNoRowsTemplate();
    }

    doesExternalFilterPass(node: any) {
        switch (this.filterType) {
            case 'allNotes':
                return !node.data.isUIdeleted;
            case 'activeNotes':
                return !node.data.isUIdeleted && !node.data.isArchive;
            case 'archivedNotes':
                return !node.data.isUIdeleted && node.data.isArchive;
            default:
                return !node.data.isUIdeleted;
        }
    }
    // updateColDefs()
    // {
    //     switch (this.filterType) {
    //         case 'allNotes':
    //            this.setDefaultColdefs();
    //            this.setOverlayNoRowsTemplate();
    //             break;
    //         case 'activeNotes':
    //             this.setDefaultColdefs();
    //             this.setOverlayNoRowsTemplate();
    //             break;
    //         case 'archivedNotes':
    //             this.removeDeleteAllHeadder();
    //             this.setOverlayNoRowsTemplate();
    //             break;
    //         default:
    //             this.setDefaultColdefs();
    //             this.setOverlayNoRowsTemplate();
    //             break;
    //     }
    // }
    setOverlayNoRowsTemplate() {
        let allNotesCount = 0;
        this.gridOptions.overlayNoRowsTemplate = "No active notes for this portfolio.";

        switch (this.filterType) {
            case 'allNotes':
                if(this.data) {
                  let allNotes: IPortfolioNotes[]  = this.data.filter((x:any) => !x.isUIdeleted );
                  allNotesCount = allNotes.length;
                }
                break;
            case 'activeNotes':
                if(this.data) {
                    let allNotes: IPortfolioNotes[]  = this.data.filter((x:any) => !x.isUIdeleted && !x.isArchive);
                    allNotesCount = allNotes.length;
                }
                break;
            case 'archivedNotes':
                this.gridOptions.overlayNoRowsTemplate = "No archived notes for this portfolio.";
                if(this.data) {
                    let allNotes: IPortfolioNotes[]  = this.data.filter((x:any) => !x.isUIdeleted && x.isArchive);
                    allNotesCount = allNotes.length;
                }
                break;
            default:
                if(this.data) {
                    let allNotes: IPortfolioNotes[]  = this.data.filter((x:any) => !x.isUIdeleted );
                    allNotesCount = allNotes.length;
                }
                break;
        }

        this.grid?.api.setGridOption('overlayNoRowsTemplate', this.gridOptions.overlayNoRowsTemplate);
        (allNotesCount === 0) ? this.grid?.api.showNoRowsOverlay() : this.grid?.api.hideOverlay();
    }
    // removeDeleteAllHeadder()
    // {
    //   this.gls.sizeFor["comment"]=356;
    //   let currentColDefs= this.gls.getColumnDefs(this);
    //   let updatedColDefs=currentColDefs.filter((coldef:any)=>
    //       coldef.headerName!="Delete All"
    //    )
    //   this.grid.api.setGridOption('columnDefs', updatedColDefs);
    // }
    // setDefaultColdefs()
    // {
    //     this.grid.api.setGridOption('columnDefs', this.gls.getColumnDefs(this));
    // }


    updateRow(params: any) {
        if (this.grid.api && this.grid.api) {
            const n = params.node;
            n.data.isArchive = true;
            params.data.isNoteEdited = true;
            this.grid.api.redrawRows({rowNodes: [n]});
            this.updateRowCounts();
            this.loadGrid();
            this.change.emit(true);
        }
    }

    updateRowArchive(params: any) {
        if (this.grid.api && this.grid.api) {
            const n = params.node;
            n.data.isArchive = false;
            params.data.isNoteEdited = true;
            this.grid.api.redrawRows({rowNodes: [n]});
            this.loadGrid();
            this.updateRowCounts();
            this.change.emit(true);
        }
    }

    removeDeleteColumn(params: any) {
        return params.data.isArchive === false;
    }

    externalFilterChanged() {
        this.cancelEditNote();
        this.setOverlayNoRowsTemplate();
        this.grid.api.onFilterChanged();
    }

    updateRowCounts() {
        if (this.data) {
            this.archivedRowCount = this.data.filter(x => x.isArchive !== null && x.isArchive).length;
            this.activeRowCount = this.data.filter(x => x.isArchive !== null && !x.isArchive).length;
        }
    }

    addPorfolioNotes() {
        this.listOfNotes = {} as IPortfolioNotes;
        this.listOfNotes.isArchive = false;
        const dCreated = new DatePipe('en-Us').transform(new Date(), 'MM/dd/yyyy h:mm:ss a');
        this.listOfNotes.createdDate = new Date(dCreated).getTime();
        this.listOfNotes.modifiedDate = new Date(dCreated).getTime();
        this.listOfNotes.isNoteEdited = true;
        // this.listOfNotes.createdDate = formatDate(this.currentSelectedTime, 'dd-MM-yyyy hh:mm:ss a', 'en-US', '-0400')
        this.listOfNotes.comment = this.multiLineComment;
        this.listOfNotes.isUIdeleted = false;
        this.listOfNotes.isNew = true;
        this.listOfNotes.createdBy = this.userDetail;
        this.listOfNotes.modifiedBy = this.userDetail;
        this.listOfNotes.priority = 'Medium';
        this.listOfNotes.noteId = null;
        this.listOfNotes.environmentId = null;
        this.data.push(this.listOfNotes);
        this.filterType = 'allNotes';
        this.externalFilterChanged();
        this.loadGrid();
        if (this.gridOptions && this.grid.api && this.grid.api.applyColumnState) {
            //this.grid.api.setSortModel([{colId: 'modifiedDate', sort: "desc"}]);
            this.grid.api.applyColumnState({ defaultState: {sort: null} });
            this.grid.api.applyColumnState({state: [{colId: 'modifiedDate', sort: "desc"}] });
        }
        this.change.emit(true);
        this.multiLineComment = '';
        this.canNotCreateNote = true;
    }
    updatePortfolioNotes() {
        const dCreated = new DatePipe('en-Us').transform(new Date(), 'MM/dd/yyyy h:mm:ss a');
        this.editNoteParams.data.comment = this.multiLineComment;
        this.editNoteParams.data.modifiedDate = new Date(dCreated).getTime();
        this.editNoteParams.data.isNoteEdited = true;
        if (this.editNoteParams.context)
            delete this.editNoteParams.context.currentNoteId;
        this.editNoteParams.api.redrawRows({rowNodes: [this.editNoteParams.node]});
        this.isNoteBeingEdited = false;
        this.canNotCreateNote = true;
        this.multiLineComment = null;
        this.change.emit(true);
    }
    cancelEditNote() {
        if (this.editNoteParams && this.editNoteParams.context) {
            delete this.editNoteParams.context.currentNoteId;
            let p = {
                force: true,
                suppressFlash: false,
                columns: [this.editNoteParams.column],
            };
            if (this.grid && this.grid.api)
                this.grid.api.refreshCells(p);
        }
        this.isNoteBeingEdited = false;
        this.canNotCreateNote = true;
        this.editNoteParams = null;
        this.multiLineComment = null;
    }
    onArchive(params: any) {
        if(this.isNoteBeingEdited && this.editNoteParams) {
            if(((params?.data?.isNew && params?.data?.createdDate === this.editNoteParams?.data?.createdDate) ||
                ((!params?.data?.isNew) && (params?.data?.noteId === this.editNoteParams?.data?.noteId)))) {
                this.cancelEditNote()
            }
        }
        /*
        if((params?.data?.isNew)) {
            for (let i = 0; i < this.data.length; i++) {
                if (this.data[i].createdDate === params.data.createdDate) {
                    this.data[i].isArchive = true;
                    break;
                }
            }
        } else if ((!params?.data?.isNew)) {
            for (let i = 0; i < this.data.length; i++) {
                if (this.data[i].noteId === params.data.noteId) {
                    this.data[i].isArchive = true;
                    break;
                }
            }
        }
        */
        this.updateRowCounts();
        this.change.emit(true);
    }
    onNoteBeingDeleted(data: any) {
        if(this.isNoteBeingEdited && this.editNoteParams) {
            if(((data?.isNew && data?.createdDate === this.editNoteParams?.data?.createdDate) ||
                ((!data?.isNew) && (data?.noteId === this.editNoteParams?.data?.noteId)))) {
                this.cancelEditNote()
            }
        }
    }

    onKeyUpChange() {
        if (this.multiLineComment.length !== 0) {
            let isValid = this.notesPattern.test(this.multiLineComment);
            if(isValid) {
                this.canNotCreateNote = false;
            } else {
                this.canNotCreateNote = true;
            }
        } else {
            this.canNotCreateNote = true;
        }
    }
    isNoteValid() {
        if ( this.multiLineComment && this.multiLineComment.length !== 0) {
            return this.notesPattern.test(this.multiLineComment);
        } else {
            return true;
        }
    }

    @Input()
    get data(): Array<IPortfolioNotes> {
        return this._data;
    }

    set data(d: Array<IPortfolioNotes>) {
        this._data = d;
        this.updateRowCounts();
    }

    @Input()
    set grid(g: any) {
        this._grid = g;
    }

    get grid() {
        return this._grid;
    }

    set gridOptions(gridOpns: any) {
        this._gridOptions = gridOpns;
    }

    get gridOptions() {
        return this._gridOptions;
    }

    get listOfNotes() {
        return this._listOfNotes;
    }

    set listOfNotes(pr: IPortfolioNotes) {
        this._listOfNotes = pr;
    }

    get archivedRowCount() {
        return this._archivedRowCount;
    }

    set archivedRowCount(n: number) {
        this._archivedRowCount = n;
    }

    get activeRowCount() {
        return this._activeRowCount;
    }

    set activeRowCount(n: number) {
        this._activeRowCount = n;
    }

    isExternalFilterPresent() {
        return true;
    }

    cancelDelete() {
        this.ctas.remove();
    }

    getRowCount() {
        return (this.data) ? this.data.length : 0;
    }

    exportNotes() {

        const headerName = this.grid.api.getAllDisplayedColumns()[0]["colDef"]["headerName"];
        if (headerName === "Delete All") {
            this.grid.api.getAllDisplayedColumns().splice(0, 1);
        }

        let colDef = JSON.parse(JSON.stringify(this.gridOptions.columnDefs));
        if (colDef && colDef.length > 0) {
            const index = colDef.findIndex((col: any) => {
                if (col.headerName === 'Delete All') {
                    return true;
                }
            });
            if (index >= 0) {
                colDef.splice(index, 1);
            }
        }
        const formatter = (res: IPortfolioNotes[]) => {
            res.forEach((r: any) => {
                if (r.modifiedDate) {
                    r.modifiedDate = this.datePipe.transform(this.easternTimePipe.transform(r.modifiedDate), 'MM/dd/yyyy h:mm a') + ' ET';
                }
                if (r.comment) {
                    r.comment = r.comment.includes(",") ? "\"" + r.comment + "\"" : r.comment;
                }

                r.status = r.isArchive ? 'Archived' : 'Active';

            });
            return res;
        };

        let exportData = JSON.parse(JSON.stringify(this.getDataForExport()));
        this.ges.setPrefix("Portfolio_Notes", "csv");
        this.ges.setExportOptions(formatter(exportData), this.grid.api, this.gridOptions, colDef);
    }

    getDataForExport(): Array<IPortfolioNotes> {
        switch (this.filterType) {
            case 'allNotes':
                return this.data.filter(note => !note.isUIdeleted);
            case 'activeNotes':
                return this.data.filter(note => (!note.isUIdeleted && !note.isArchive));
            case 'archivedNotes':
                return this.data.filter(note => (!note.isUIdeleted && note.isArchive));
            default:
                return this.data;
        }
    }
}
